import { BToast } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBToast = createEgBootstrapProxy("EgBToast", BToast);
